import { useQuery } from "react-query";
import { customerBusinessService } from "../services";

const getCustomerAddresses = async (customerId: string | number) => {
  const response = await customerBusinessService.getCustomerAddresses(customerId);
  const data = response?.data?.data;
  return Array.isArray(data) ? data : data?.addresses ?? [];
};

export default function useCustomerAddresses(
  customerId: string | number,
  enabled = false
) {
  return useQuery(
    ["customerAddresses", customerId],
    () => getCustomerAddresses(customerId),
    {
      enabled: enabled && !!customerId,
      retry: false,
      // Keep guest addresses cached for the session until place-order clears
      // the cache (removeQueries) or the page is refreshed (in-memory only).
      staleTime: Infinity,
      cacheTime: 1000 * 60 * 60,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );
}
